<template>
  <div class="header">
    <img class="logo" src="@/assets/images/logo.png" />
    <div class="nav-icon" @click="toggle()">
      <img v-if="navShow" src="@/assets/images/close.png" />
      <img v-else src="@/assets/images/nav.png" />
    </div>
    <div class="navs" v-if="navShow">
      <a @click="go('/')">
        <span>首页</span>
      </a>
      <!-- <a @click="go('/news')">
        <span>优选资讯</span>
      </a> -->
      <a @click="go('/about')">
        <span>关于我们</span>
      </a>
      <a @click="go('/contact')">
        <span>联系我们</span>
      </a>
      <a @click="go('/download')">
        <span>下载APP</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navShow: false,
    };
  },
  created() {},
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    toggle() {
      this.navShow = !this.navShow;
    },
    go(path){
      this.navShow = false
      if(this.$route.path === path){
        return
      }
      this.$router.push(path)
    },
  },
  beforeDestroy() {},
  components: {},
};
</script>

<style scoped lang="less">
.header {
  padding: 0 0.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  z-index: 9;
  left: 0;
  right: 0;
  top: 0;
  height: 0.5rem;
  background: #fff;
  .logo {
    height: 0.24rem;
    width: auto;
  }
  .nav-icon {
    height: 0.3rem;
    width: 0.3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      height: 0.24rem;
      width: auto;
    }
    &:active {
      opacity: 0.5;
    }
  }

  .navs {
    background: #fff;
    position: absolute;
    box-shadow: rgba(0, 0, 0, 0.1) 0 0.6rem 1rem;
    top: 0.5rem;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    border-top: #f5f5f5 0.01rem solid;
    padding: 0.1rem 0 0.2rem 0;
    a {
      color: #000;
      font-size: 0.16rem;
      padding: 0.1rem 0 0.1rem 0.2rem;
      &:active {
        opacity: 0.5;
      }
      &.a-exact-active {
        font-weight: bold;
        color: #ff4f6a;
      }
    }
  }
}
</style>
